const problemdata = {
  state: () => ({
    checkListFlag: []
  }),
  mutations: {
    setCheckList(state, checkListFlag) {
      state.checkListFlag = checkListFlag;
    }
  },
  actions: {},
  getters: {}
};
export default problemdata;
